import { Link, useLocation } from 'react-router-dom';
import { Home, ArrowLeftRight, TrendingUp, CreditCard, Menu } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  
  const tabs = [
    { path: '/home', icon: Home, label: 'Home' },
    { path: '/payments', icon: ArrowLeftRight, label: 'Payments' },
    { path: '/earn', icon: TrendingUp, label: 'Earn' },
    { path: '/cards', icon: CreditCard, label: 'Cards' },
    { path: '/more', icon: Menu, label: 'More' },
  ];
  
  const isActive = (path) => {
    if (path === '/home') return location.pathname === '/home';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <div className="flex items-center justify-around py-2 max-w-lg mx-auto">
        {tabs.map(({ path, icon: Icon, label }) => (
          <Link
            key={path}
            to={path}
            className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-all ${
              isActive(path)
                ? 'text-primary'
                : 'text-muted-foreground hover:text-white'
            }`}
            data-testid={`nav-${label.toLowerCase()}`}
          >
            <Icon className={`w-6 h-6 ${isActive(path) ? 'stroke-[2.5]' : ''}`} />
            <span className="text-xs font-medium">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
